import styled, { css } from "styled-components";
// import Colors from "../../assets/theme/colors";

const buttonCssResets = css`
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	background: transparent;
	/* inherit font & color from ancestor */
	color: inherit;
	font: inherit;
	/* Normalize 'line-height'. Cannot be changed from 'normal' in Firefox 4+. */
	line-height: normal;
	/* Corrects font smoothing for webkit */
	-webkit-font-smoothing: inherit;
	-moz-osx-font-smoothing: inherit;
	/* Corrects inability to style clickable 'input' types in iOS */
	-webkit-appearance: none;
	/* Remove excess padding and border in Firefox 4+ */
	&::-moz-focus-inner {
		border: 0;
		padding: 0;
	}
`;

const buttonNecessaryCss = css`
	height: ${(props) => (props.height ? props.height : "56px")};
	border-radius: 4px;
	padding: 0px 40px;
	font-weight: 900;
	text-align: center;
	min-width: 70px;
	transition: all 0.3s ease-out;
	position: relative;
	cursor: pointer;
`;

const buttonLinkCss = (prop) =>
	prop.link &&
	prop.as === "a" &&
	css`
		display: inline-block;
		text-decoration: none;
		line-height: 55px;
	`;

const buttonHoverState = (prop) => {
	/* Default is Primary */
	if (prop.link && prop.as === "a") {
		return css`
			background-color: #2bb793;
			color: #fff;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
		`;
	}
	if (prop.link) {
		return css`
			background-color: transparent;
			border: none;
			text-decoration: underline;
			color: #2bb793;
			box-shadow: none;
		`;
	}
	if (prop.secondary) {
		return css`
			background-color: #2bb793;
			color: #ffffff;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
			border: 1px solid #2bb793;
		`;
	}
	return css`
		background-color: #2bb793;
		color: #ffffff;
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.39);
	`;
};
const buttonFocusState = css`
	outline: none;
`;

const buttonTextColor = (prop) => {
	/* Default is Primary */
	if (prop.link && prop.as === "a") {
		return css`
			color: #fff;
		`;
	}
	if (prop.link) {
		return css`
			color: #2bb793;
		`;
	}
	if (prop.secondary) {
		return css`
			color: #2bb793;
		`;
	}
	return css`
		color: #ffffff;
	`;
};

const buttonBackgroundColor = (prop) => {
	/* Default is Primary */
	if (prop.link && prop.as === "a") {
		return css`
			background-color: #2bb793;
		`;
	}
	if (prop.link) {
		return css`
			background-color: transparent;
			border: none;
		`;
	}
	if (prop.secondary) {
		return css`
			background-color: transparent;
			border: 1px solid #2bb793;
		`;
	}
	if (prop.primary) {
		return css`
			background-color: #4d3951;
		`;
	}
	return css`
		background-color: #2bb793;
	`;
};

const fullWidthButton = (prop) => {
	if (prop.fullWidth) {
		return css`
			width: 100%;
		`;
	}
	return css`
		width: auto;
	`;
};

const buttonFont = (prop) => {
	if (prop.fontSize) {
		return css`
			font-size: ${prop.fontSize};
		`;
	}
	return css`
		font-size: 20px;
	`;
};

const Button = styled.button`
	${buttonCssResets} /* To Remove all default css from the button */
    ${buttonNecessaryCss}
    ${buttonLinkCss}
    ${buttonTextColor}
    ${buttonBackgroundColor}
    ${fullWidthButton}
    ${buttonFont}
    &:hover {
		${buttonHoverState}
	}
	&:focus {
		${buttonFocusState}
	}
`;

export default Button;
